import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Flex } from 'reflexbox'
import FinalReport from 'containers/Greenlight/FinalReport/index'
import progressBarHoc from 'containers/Async/AsyncProgressBar'
import Dialog from './Dialog'

import {
  projectValueSelector,
  activeDialogStateSelector,
  actionTypeStateSelector,
} from './selectors'

import {
  FETCH_REVISIONS,
  FETCH_APPROVALS,
  FETCH_PROJECT
} from './constants'
import {
  POST_FASTTRACK
} from 'containers/Project/GreenlightSection/constants'

import {
  onDialogCancel,
  onDialogSubmit
} from './actions'

const ProgressBar = progressBarHoc([FETCH_REVISIONS, FETCH_APPROVALS, FETCH_PROJECT, POST_FASTTRACK])

const mapStateToProps = (state) => {
  return {
    project: projectValueSelector(state),
    active: activeDialogStateSelector(state),
    actionType: actionTypeStateSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDialogCancel: () => dispatch(onDialogCancel()),
    onDialogSubmit: () => dispatch(onDialogSubmit())
  }
}

const GreenlightReport = props => {
  const {
    project,
    active,
    onDialogCancel,
    onDialogSubmit,
    actionType
  } = props

  return (
    <div>
      <ProgressBar/>
      {
        project ? <FinalReport/> : null
      }
      <Dialog
        active={active}
        actionType={actionType}
        onDialogCancel={onDialogCancel}
        onDialogSubmit={onDialogSubmit}
      />
    </div>
  )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect
)

export default enhance(GreenlightReport)
